import i18n from '@/locale'

const isClientVersion = process.env.VUE_APP_TARGET === 'client'

export default {
  state: {
    loading: false,
    locale: 'de',
    locales: [
      {
        label: 'DE',
        value: 'de'
      },
      {
        label: 'EN',
        value: 'en'
      }
    ],
    version: isClientVersion ? 'client' : 'admin'
  },
  getters: {
    getApp: state => state
  },
  mutations: {
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_LOCALE (state, data) {
      state.locale = data
    }
  },
  actions: {
    setLocale ({ state, commit, dispatch, rootState }, locale) {
      commit('SET_LOCALE', locale)
      i18n.locale = locale
      window.localStorage.setItem('locale', locale)
    }
  }
}
